class SectionBackground extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      rootMargin: '-45% 0px -45% 0px',
      threshold: [0, 1],
    })
    // We need to observe the video element as the host element has display: contents on it. IntersectionObserver won't work on an element that is set to display: contents
    this.observer.observe(this)
  }

  onEntry ([entry], observer) {
    if (!entry.isIntersecting) return

    this.externalEls.body.element.style.setProperty(
      '--Theme_Color',
      this.dataset.backgroundColor,
    )
  }
}

if (!customElements.get('section-background')) {
  customElements.define('section-background', SectionBackground)
}
